import { Stack, Typography } from '@mui/material'
import { GridGroupNode, useGridApiContext } from '@mui/x-data-grid-premium'
import { useTranslation } from 'react-i18next'
import { ROW_GROUPING_NONE_GROUPING_TEXT_VALUE } from '../helpers'

interface Props {
  columnHeaderName: string
  value: string
  id: string | number
}

export const RowGroupingColumnTableCell: React.FC<Props> = ({ columnHeaderName, value, id }) => {
  const { t } = useTranslation('common')
  const apiRef = useGridApiContext()

  const tableCellText = value === ROW_GROUPING_NONE_GROUPING_TEXT_VALUE ? t('row-grouping.none-row-grouping-value') : value

  return (
    <Stack
      onClick={(e) => {
        e.stopPropagation()
        if (!apiRef.current?.getRowNode) return // Fixes bug when you click on grouped row name instead of the expand button
        apiRef.current.setRowChildrenExpansion(id, !apiRef.current.getRowNode<GridGroupNode>(id)?.childrenExpanded)
      }}
      direction="row"
      gap={1}
    >
      <Typography variant="Body14pxRegular">{columnHeaderName}:</Typography>
      <Typography variant="Body14pxMedium">{tableCellText}</Typography>
    </Stack>
  )
}
